import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { ComponentsModule } from '../components/components.module';
import { LoginPage } from './login.page';

@NgModule({
  declarations: [
    LoginPage,
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    FormsModule,
    IonicModule,
    RouterModule,
  ],
  exports: [
    LoginPage,
  ],
})
export class LoginModule { }
